<div class="flex min-h-dvh flex-col bg-background text-foreground">
  @if (!networkService.isOnline()) {
    <p class="bg-warning px-4 py-2 text-center text-xs text-warning-foreground">
      {{ "common.offline" | translate }}
    </p>
  }

  @if (showShellChrome()) {
    <mobile-header
      [titleKey]="headerTitleKey()"
      [titleText]="headerTitleText()"
      [showBackToApps]="!!appContext.activeApplication()"
      [showBurger]="!!appContext.activeApplication()"
      [showLogout]="false"
      (burgerToggle)="toggleBurger()"
    />

    <mobile-burger-drawer
      [open]="burgerOpen()"
      [sections]="appContext.drawerSections()"
      [activeAppName]="headerTitleText()"
      (closed)="closeBurger()"
      (backToApps)="onBackToApps()"
      (menuSelected)="onMenuSelected($event)"
      (itemSelected)="onItemSelected($event)"
    />
  }

  <main
    class="mx-auto flex min-h-0 w-full flex-1 flex-col overflow-hidden"
    [class.max-w-xl]="!isOnLauncher()"
    [class.px-3]="!isOnLauncher()"
    [class.pt-4]="!isOnLauncher()"
    [class.pb-4]="!showBottomNav() && !isOnLauncher()"
  >
    <!-- Scroll ici : même hauteur que la zone utile, padding bas réservé à la bottom nav fixe. -->
    <div
      class="mobile-shell-router-host flex min-h-0 min-w-0 w-full flex-1 flex-col basis-0 overflow-y-auto overscroll-y-contain"
      [class.mobile-shell-router-host--bottom-nav]="showBottomNavDock()"
      [class.mobile-shell-router-host--fixed-bottom-composer]="
        showBottomNav() && fixedBottomComposerLayout()
      "
      [class.mobile-shell-router-host--composer-focus-no-dock]="composerFocusNoDock()"
      [class.pb-4]="!showBottomNav() && !isOnLauncher()"
    >
      <router-outlet />
    </div>
  </main>

  @if (showBottomNavDock()) {
    <mobile-bottom-nav [items]="bottomNavItems()" />
  }

  @if (showBottomNavDock() && quickAccessItems().length > 0) {
    <mobile-quick-access-fab [items]="quickAccessItems()" />
  }
</div>
